export type MaintenanceViewTranslation = {
  endDateLabel: string;
  fallbackMessage: string;
  title: string;
};

export const maintenanceViewTranslation: MaintenanceViewTranslation = {
  endDateLabel: 'Przewidywany koniec prac',
  fallbackMessage: 'Trwają prace serwisowe. Przepraszamy za utrudnienia.',
  title: 'Trwają prace serwisowe',
};
